<div class="CatalogFilter" uk-accordion="multiple: true; duration: 300;">
	<ng-template [ngIf]="sectionService.sections.length > 0">
	<div class="CatalogFilter_Item" *ngFor="let category of sectionService.sections" [ngClass]="category.SELECTED ? 'uk-open' : ''">
		<div class="CatalogFilter_Heading CatalogFilter_Heading--click uk-accordion-title">
			<span class="IconItem" [ngClass]="'IconItem--' + category.CODE">
				<img [src]="'/assets/img/icon/' + category.CODE + '.svg'" alt="" uk-svg>
			</span>

			<span>{{ category.NAME }} <span class="uk-text-primary">({{ category.ELEMENTS_COUNT }})</span></span>

			<span class="IconItem IconItem--arrowTop">
				<img src="/assets/img/icon/arrow-top.svg" alt="" uk-svg>
			</span>
		</div>

		<ul class="CatalogFilter_List uk-accordion-content" uk-accordion="multiple: true; duration: 300;">
			<ng-template [ngIf]="category.SUBSECTIONS.length > 0">
				<li *ngFor="let section of category.SUBSECTIONS" [ngClass]="section.SELECTED ? 'uk-open' : ''">
					<a class="CatalogFilter_List_Item uk-accordion-title"
						[routerLink]="section.SUBSECTIONS.length > 0 ? null : cityService.city.CODE
					? ['/regions', cityService.city.CODE, 'catalog', 'section', section.CODE || section.ID]
				 	: ['/catalog/section/', section.CODE || section.ID]"
						[routerLinkActive]="section.SUBSECTIONS.length > 0 ? '' : 'uk-active'" [routerLinkActiveOptions]="{exact: true}">
						<span class="CatalogFilter_List_Icon" [style.background-image]="section.PICTURE ? 'url(' + section.PICTURE.SRC + ')' : ''"></span>
						<span class="CatalogFilter_List_Name" [ngClass]="section.SUBSECTIONS.length > 0 ? 'CatalogFilter_List_Name--list' : ''"
						>{{ section.NAME }}</span>
					</a>

					<div class="uk-accordion-content uk-margin-remove-top">
						<ng-template [ngIf]="section.SUBSECTIONS.length > 0">
							<a *ngFor="let subSection of section.SUBSECTIONS"
								class="CatalogFilter_List_Name CatalogFilter_List_Name--sub"
								[routerLink]="cityService.city.CODE
					? ['/regions', cityService.city.CODE, 'catalog', 'section', subSection.CODE || subSection.ID]
				 	: ['/catalog/section/', subSection.CODE || subSection.ID]"
								routerLinkActive="uk-active" [routerLinkActiveOptions]="{exact: true}"
							>{{ subSection.NAME }}</a>
						</ng-template>
					</div>
				</li>
			</ng-template>
		</ul>
	</div>
	</ng-template>

	<div *ngFor="let prop of filterProperties" class="CatalogFilter_Item">
		<ng-template [ngIf]="prop.CODE === 'PRICE'">
			<div class="CatalogFilter_Heading uk-accordion-title">
				<span>{{prop.NAME}}&nbsp;</span>
				<label [attr.for]="'catFilter' + prop.CODE + 'From'">от</label>

				<input class="uk-input"
					[id]="'catFilter' + prop.CODE + 'From'"
					type="number"
					[disabled]="loadingState"
					[(ngModel)]="filterPrice[0]"
					(ngModelChange)="triggerChangePrice()"
				>

				<label [attr.for]="'catFilter' + prop.CODE + 'To'">до</label>

				<input class="uk-input"
					[id]="'catFilter' + prop.CODE + 'To'"
					type="number"
					[disabled]="loadingState"
					[(ngModel)]="filterPrice[1]"
					(ngModelChange)="triggerChangePrice()"
				>
			</div>

			<div class="uk-accordion-content uk-margin-remove"></div>
		</ng-template>

		<ng-template [ngIf]="prop.CODE !== 'PRICE' && prop.DISPLAY_TYPE === 'F'">
			<div class="CatalogFilter_Heading CatalogFilter_Heading--click uk-accordion-title">
				<span>{{prop.NAME}}</span>

				<span class="IconItem IconItem--arrowTop">
					<img src="/assets/img/icon/arrow-top.svg" uk-svg>
				</span>
			</div>

			<div class="CatalogFilter_Checkboxes uk-accordion-content uk-margin-remove-top">
				<label *ngFor="let value of prop.VALUES" class="CheckboxBtn uk-position-relative uk-flex uk-flex-middle">
					<input type="checkbox"
						[name]="prop.CODE"
						[value]="value.VALUE"
						[disabled]="loadingState"
						(change)="changeProp(value)"
					>
					<span class="CheckboxFlag"></span>
					<span>{{ value.VALUE }}</span>
				</label>
			</div>
		</ng-template>
	</div>

	<div class="CatalogFilter_Item">
		<div class="CatalogFilter_Heading uk-accordion-title">
			<span>Сортировать по</span>
			<select class="uk-select"
				name="sort"
				[disabled]="loadingState"
				[(ngModel)]="sortOption"
				(change)="changeOrder()"
			>
				<option *ngFor="let sort of sortList; let i = index" [value]="i">{{ sort.name }}</option>
			</select>
		</div>

		<div class="uk-accordion-content uk-margin-remove"></div>
	</div>

	<!-- <div class="CatalogFilter_Item">
		<a class="CatalogFilter_Heading" routerLink="/compare">
			<span>В сравнении</span>
			<span class="CatalogFilter_Heading_Counter">{{compareService.compare.length}}</span>
		</a>
	</div> -->
</div>
